// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	enableLogger: true,
	gateway: 'https://etec-orch.org/gateway',
	cms: 'https://etec-orch.org/cms',
	appConfig: {
		endpoint: '/api/collections/get/AppConfig1/',
		id: '6069bbe7666434004e00012d',
		frontOfficeSettings: 'api/singletons/get/frontOfficeSettings',
		formioEndpoint: '/api/collections/get/formioConfig/',
		formioId: '612bc06a5d4cda7713720b52',
		formioSettings: 'api/singletons/get/formioSettings',
	},
	keycloak: {
		url: 'https://etec-orch.org/auth/',
		realm: 'etec',
		clientId: 'fo-web',
		disableLoginRedirectUri: false
	},
	formio: {
		apiUrl: 'https://etec-orch.org/formioApi/',
		appUrl: 'https://etec-orch.org/formioUrl/',
	},
	endpoints: {
		tasks: '/requestmanagement/api/portal/tasks',
		anonymousTasks: '/requestmanagement/api/portal/tasks/anonymous',
		camundaTask: '/requestmanagement/rest/task',
		myRequests: '/requestmanagement/api/portal/requests',
		myBeneficiarySegments: '/requestmanagement/api/portal/beneficiary-segments-cms',
		caseActivity: '/requestmanagement/rest/history/case-activity-instance',
		caseActivityDetails: '/requestmanagement/rest/history/detail',
		count: '/requestmanagement/api/requests/count',
		statuses: '/requestmanagement/api/portal/eservices',
		beneficiaryApi: '/dataservice/api/portal/beneficiaries',
		deparments: '/referencedata/api/portal/departments',
		services: '/referencedata/api/request/eservices',
		servicesNew: '/requestmanagement/api/portal/eservices',
		filterStatuses: '/referencedata/departments',
		request: '/referencedata/caseNames',
		account: '/api/account',
		humanTask: '/dataservice/api/tasks/case/',
		notifications: '/notification/api/',
		socket: '/notification/websocket/orchestra',
		dataservice: '/dataservice/api/',
		eligibilityVerificationReportApi: '/reportingservice/api/requirements',
		requestFeedback: '/feedbackservice/api/v2/feedbacks/service',
		reportingservice: '/reportingservice/api/',
		criterionInformations: '/reportingservice/api/v1/criterion-informations/',
		finalCriterionInformations: '/reportingservice/api/v1/criterion-final-reports/',
		criterion: '/reportingservice/api/criterion/',
		visitMembers: '/reportingservice/api/visit-members/',
		executivePlan: '/reportingservice/api/executive-plans/',
		customExecutivePlan: '/reportingservice/api/v1/executive-plans/',
		finalReportMistakes: '/reportingservice/api/final-report-mistakes',
		finalReportResponses: '/reportingservice/api/v1/final-report-responses/',
		masarCriteria: '/reportingservice/api/masar-criteria/',
		assessmentResource: {
			process: 'proccessassessmentresult',
			categories: 'categoryassessmentresult',
			questions: 'questionsassessmentresult',
		},
	},
	keys: {
		attachments: 'attachmentssm',
		attachmentsId: '63d78e1cd6bca98f19758ac2',
	},
	roles: {
		beneficiary: 'ROLE_BENEFICIARY',
		branch_specialist: 'ROLE_SERVICE_SPECIALIST_BRANCH',
		department_specialist: 'ROLE_DEPARTMENT_ENABLEMENT_SPECIALIST',
		admin: 'ROLE_ADMIN',
	},
	serviceCatalogControl: {
		showCarousel: false,
		showHasTask: true,
		showMostUsedService: true,
		showCatalog: false,
	},
	pdftronLicenceKey: '',
	showFeedbackButton: true,
	showDashboardCounters: true,
	skipServiceDetailsPage: false,
	backToTop: true,
	taskRedirection: true,
	enableFormioHelpers: false,
	matomoConfig:{
		enable: false,
		trackerUrl: '3.235.13.55:8080',
		appDomain: 'etec-orch.org',
		siteId: 1
	}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
